import Heading from "./basic";
import ScrollingHeading from "./scrolling";
import StylizedHeading from "./stylized";

export { Heading, ScrollingHeading, StylizedHeading };